import { translationStatistics_sv_part1 } from "./translationStatistics.sv.part1";
import { translationStatistics_sv_hours } from "./translationStatistics.sv.hours";
import { defineTranslationTree } from "./translationTypes";
import { translationStatistics_sv_part2 } from "./translationStatistics.sv.part2";
import { translationStatistics_sv_part3 } from "./translationStatistics.sv.part3";
import { translationStatistics_sv_part4 } from "./translationStatistics.sv.part4";
import { translationStatistics_sv_part5 } from "./translationStatistics.sv.part5";

export const translationStatistics_sv = defineTranslationTree({
  aiClickRate: "Klickfrekvens för produkter och länkar",
  aiClickRateTooltip:
    "Konversationer med ett klick dividerat med konversationer som visades en AI-länk eller produktåtgärd. Varje konversation räknas en gång; visad betyder renderad i chatten, även under det synliga området.",
  hyperlinkClickRate: "Hyperlänkar",
  productClickRate: "Produktkort",
  clickRateCounts: "{clicked} av {eligible} konversationer",
  clickRateViewBreakdown: "Visa klickfrekvens för hyperlänkar och produkter",
  clickRateBreakdownHint:
    "Varje typ använder sina egna visade konversationer som nämnare. En konversation kan klicka på båda typerna, så dessa frekvenser summerar inte. Produktklick inkluderar att öppna en produkt, lägga till i varukorg och önskelista; uppföljningsfrågor exkluderas.",
  clickRateTrackingNote:
    "Baserat på registrerade exponeringar sedan klickspårningen lanserades. Historiska chattar utan registrerade exponeringar exkluderas.",
  ...translationStatistics_sv_part1,
  ...translationStatistics_sv_part2,
  ...translationStatistics_sv_part3,
  ...translationStatistics_sv_part4,
  ...translationStatistics_sv_part5,
  ...translationStatistics_sv_hours,
});
